import React, { FC } from 'react';
import styles from 'components/Cart/OrderSummary/OrderSummary.module.scss';
import { SubtotalTitle } from 'components/Cart/OrderSummary/SubtotalTitle/SubtotalTitle';
import hardwarePaymentStyles from 'components/Cart/OrderSummary/HardwarePayment/HardwarePayment.module.scss';
import { useTranslation } from 'react-i18next';
import { SummarySection } from './SummarySection/SummarySection';
import { useCartContext } from 'components/Cart/hooks/useCartContext';

interface ISoftwarePlanProps {
  isCheckout?: boolean;
}

export const SoftwarePlan: FC<ISoftwarePlanProps> = ({ isCheckout }) => {
  const { t } = useTranslation();
  const { cart, checkout } = useCartContext();

  if (!cart.softwarePlan) return null;

  return (
    <section className={styles.section}>
      <SubtotalTitle summaryTitle={t('order-summary.monthly-fee')} isCheckout={isCheckout} />
      <div className={hardwarePaymentStyles.containerBordered}>
        <SummarySection
          subheading={t('cart-page.plan-name', { planName: cart.softwarePlan.name })}
          price={t('order-summary.monthly-price', { price: checkout.softwareTotal })}
        />
      </div>
    </section>
  );
};
